import { createFileRoute } from '@tanstack/react-router'

import {
  listSearchValidator,
  useListFilters,
} from '@/components/Internal/DataTable'
import { queueListFilters } from '@/components/Internal/Queue/queue-list-filters'
import { QueueJobsTable } from '@/components/Internal/Queue/QueueJobsTable'
import { QueueOverview } from '@/components/Internal/Queue/QueueOverview'

export const Route = createFileRoute('/internal/system/operations/queue')({
  validateSearch: listSearchValidator(queueListFilters),
  component: QueueScreen,
})

function QueueScreen() {
  const filters = useListFilters(queueListFilters, Route)

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <QueueOverview />
      <QueueJobsTable filters={filters} card={false} />
    </div>
  )
}
